export default __webpack_public_path__ + "static/media/BOProto1.2fcf9696.png";